import Vue from "vue";
import Vuex from "vuex";

import { io } from "socket.io-client";

/* import buscarEntidadeOrgaoAPI from "../services/buscarEntidadeOrgaoAPI" */
import buscarEntidadeOrgaoContrato from "../services/buscarEntidadeOrgaoContrato";
import buscarPlanosAPI from "../services/buscarPlanosService";
import verificaEstado from "../services/verificaEstado";
import verificaElegibilidade from "../services/verificaElegibilidade";
import lerValorPlano from "../services/lerValorPlano";
import lerAuxilioSaude from "../services/lerAuxilioSaude";
import lerValorAuxilio from "../services/lerValorAuxilio";
import lerAuxilio from "../services/lerAuxilio";
import lerAbrangencia from "../services/lerAbrangencia";
import lerAcomodacao from "../services/lerAcomodacao";
import lerOperadoras from "../services/lerOperadoras";
import lerEntidadesOrgaosProtheus from "../services/lerEntidadesOrgaosProtheus";
import listarOcupacoes from "../services/listarOcupacoes";

import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

const ls = new SecureLS({
  isCompression: false,
});

const defaultState = () => {
  return {
    AliancaModalAbandono: false,
    AliancaQLCEcommerce: null,
    AliancaTermos: null,
    AliancaLogo: null,
    AliancaCEP: null,
    AliancaProxEtapa: "step-1",
    AliancaEstadoID: null,
    AliancaFuncPub: null,
    AliancaOrgaoPub: null,
    AliancaEntidadeClasse: null,
    AliancaListaOrgaoPub: null,
    AliancaListaEntidadeClasse: null,
    AliancaProfissao: "00109",
    AliancaListaProfissao: null,
    AliancaNome: null,
    AliancaDataNasc: null,
    AliancaPossuiDep: null,
    AliancaObjDependentes: null,
    AliancaEmail: null,
    AliancaTelefone: null,
    AliancaConsentimentoLGPD: null,
    AliancaEndBairro: null,
    AliancaEndCidade: null,
    AliancaEndComp: null,
    AliancaEndRua: null,
    AliancaEndGia: null,
    AliancaEndIbge: null,
    AliancaEndTipo: null,
    AliancaEndUF: null,
    AliancaOrgEnt: null,
    AliancaSelectedPlano: null,
    AliancaSelectedPlanoProtheus: null,
    AliancaNumeroContrato: null,
    AliancaSubFatura: null,
    AliancaObjCadastro: null,
    AliancaObjLogin: null,
    AliancaUsrCPF: null,
    AliancaUsrSenha: null,
    AliancaTipoEndereco: null,
    AliancaGeneroTitular: null,
    AliancaSexoTitular: null,
    AliancaDocumentoTipo: null,
    AliancaDocumentoNumero: null,
    AliancaDocumentoOrgao: null,
    AliancaDocumentoUf: null,
    AliancaDocumentoDtExpedicao: null,
    AliancaTitularNomeMae: null,
    AliancaTitularEstadoCivil: null,
    AliancaTitularDataAdmissaoOrgao: null,
    AliancaMatriculaRegOrgaoEntidade: null,
    AliancaLotacaoOrgao: null,
    AliancaTitularCertidaoNascVivo: null,
    AliancaFlagPortabilidade: null,
    AliancaObjDPS: null,
    AliancaHistoryDPS: null,
    AliancaInfoConta: {},
    AliancaFormaPagamento: null,
    AliancaObjInfoPagamento: {
      infocontaopcional: {},
    },
    AliancaPropostaFinalizada: null,
    AliancaFaixaRemuneracao: null,
    AliancaPlanosEntidadeorgaoInfo: [],
    AliancaPlanosLista: [],
    AliancaPlanosListaFormatado: [],
    AliancaPlanosFiltrosAbrangencias: [],
    AliancaPlanosFiltrosAcomodacoes: [],
    AliancaPlanosOperadorasWordpress: [],
    AliancaPlanosOperadoras: [],
    AliancaListaFaixaRemuneracao: [],
    AliancaCodAux: null,
    AliancaMinimoPreco: 0,
    AliancaMaximoPreco: 0,
    AliancaCodEnd: null,
    AliancaEndNumero: null,
    AliancaEndComplemento: null,
    AliancaProposta: null,
    AliancaStatusAnalise: false,
    AliancaBreakPlanos: false,
    simuleAqui: {
      cep: "",
      nome: "",
      datanasc: "",
      email: "",
      telefone: "",
      estadoapi: "",
      selected_entidade: "null",
      selected_orgao: "null",
      selected_orgao_cod: null,
      selected_profissao: "null",
      options_entidades: [],
      options_orgaos: [],
      options_profissoes: [],
      isLoading: false,
      tipoorgaoentidade: "",
      validaCEP: false,
      resetModeStep: false,
      consentimentolgpd: true,
      errors: [],
      incluirDependente: false,
      dependentes: [],
      finalizaprocesso: false,
      exibefinaliza: false,
      options_grauparentesco: [],
      selected_faixa: "null",
      options_faixaremuneracao: [],
      preenchidoprofissoes: false,
      traducaodatepicker: null,
    },
    AliancaFaixaRemuneracaoSelecionada: {}
  };
};

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: "alianca_ecommerce",
      overwrite: true,
      getItem: (key) => ls.get(key),
      setItem: (key, value) => ls.set(key, value),
      removeItem: (key) => ls.remove(key),
    }),
    createPersistedState({
      key: "ModalAbandonoPagina",
      storage: window.sessionStorage,
      paths: ["ModalAbandonoPagina"],
    }),
  ],
  state: defaultState(),
  getters: {
    getAliancaModalAbandono(state) {
      return state.AliancaModalAbandono;
    },
    getAliancaQLCEcommerce(state) {
      return state.AliancaQLCEcommerce;
    },
    getAliancaTermos(state) {
      return state.AliancaTermos;
    },
    getAliancaLogo(state) {
      return state.AliancaLogo;
    },
    getAliancaCEP(state) {
      return state.AliancaCEP;
    },
    getAliancaProxEtapa(state) {
      return state.AliancaProxEtapa;
    },
    getAliancaEstadoID(state) {
      return state.AliancaEstadoID;
    },
    getAliancaFuncPub(state) {
      return state.AliancaFuncPub;
    },
    getAliancaOrgaoPub(state) {
      return state.AliancaOrgaoPub;
    },
    getAliancaEntidadeClasse(state) {
      return state.AliancaEntidadeClasse;
    },
    getAliancaProfissao(state) {
      return state.AliancaProfissao;
    },
    getAliancaNome(state) {
      return state.AliancaNome;
    },
    getAliancaDataNasc(state) {
      return state.AliancaDataNasc;
    },
    getAliancaPossuiDep(state) {
      return state.AliancaPossuiDep;
    },
    getAliancaObjDependentes(state) {
      return state.AliancaObjDependentes;
    },
    getAliancaBreakPlanos(state) {
      return state.AliancaBreakPlanos;
    },
    getAliancaEmail(state) {
      return state.AliancaEmail;
    },
    getAliancaTelefone(state) {
      return state.AliancaTelefone;
    },
    getAliancaConsentimentoLGPD(state) {
      return state.AliancaConsentimentoLGPD;
    },
    getAliancaEndBairro(state) {
      return state.AliancaEndBairro;
    },
    getAliancaEndCidade(state) {
      return state.AliancaEndCidade;
    },
    getAliancaEndComp(state) {
      return state.AliancaEndComp;
    },
    getAliancaEndRua(state) {
      return state.AliancaEndRua;
    },
    getAliancaEndGia(state) {
      return state.AliancaEndGia;
    },
    getAliancaEndIbge(state) {
      return state.AliancaEndIbge;
    },
    getAliancaEndTipo(state) {
      return state.AliancaEndTipo;
    },
    getAliancaEndUF(state) {
      return state.AliancaEndUF;
    },
    getAliancaOrgEnt(state) {
      return state.AliancaOrgEnt;
    },
    getAliancaSelectedPlano(state) {
      return state.AliancaSelectedPlano;
    },
    getAliancaSelectedPlanoProtheus(state) {
      return state.AliancaSelectedPlanoProtheus;
    },
    getAliancaNumeroContrato(state) {
      return state.AliancaNumeroContrato;
    },
    getAliancaSubFatura(state) {
      return state.AliancaSubFatura;
    },
    getAliancaObjLogin(state) {
      return state.AliancaObjLogin;
    },
    getAliancaUsrCPF(state) {
      return state.AliancaUsrCPF;
    },
    getAliancaUsrSenha(state) {
      return state.AliancaUsrSenha;
    },
    getAliancaTipoEndereco(state) {
      return state.AliancaTipoEndereco;
    },
    getAliancaGeneroTitular(state) {
      return state.AliancaGeneroTitular;
    },
    getAliancaSexoTitular(state) {
      return state.AliancaSexoTitular;
    },
    getAliancaDocumentoTipo(state) {
      return state.AliancaDocumentoTipo;
    },
    getAliancaDocumentoNumero(state) {
      return state.AliancaDocumentoNumero;
    },
    getAliancaDocumentoOrgao(state) {
      return state.AliancaDocumentoOrgao;
    },
    getAliancaDocumentoUf(state) {
      return state.AliancaDocumentoUf;
    },
    getAliancaDocumentoDtExpedicao(state) {
      return state.AliancaDocumentoDtExpedicao;
    },
    getAliancaTitularNomeMae(state) {
      return state.AliancaTitularNomeMae;
    },
    getAliancaTitularEstadoCivil(state) {
      return state.AliancaTitularEstadoCivil;
    },
    getAliancaTitularDataAdmissaoOrgao(state) {
      return state.AliancaTitularDataAdmissaoOrgao;
    },
    getAliancaMatriculaRegOrgaoEntidade(state) {
      return state.AliancaMatriculaRegOrgaoEntidade;
    },
    getAliancaLotacaoOrgao(state) {
      return state.AliancaLotacaoOrgao;
    },
    getAliancaTitularCertidaoNascVivo(state) {
      return state.AliancaTitularCertidaoNascVivo;
    },
    getAliancaObjCadastro(state) {
      return state.AliancaObjCadastro;
    },
    getAliancaFlagPortabilidade(state) {
      return state.AliancaFlagPortabilidade;
    },
    getAliancaObjDPS(state) {
      return state.AliancaObjDPS;
    },
    getAliancaHistoryDPS(state) {
      return state.AliancaHistoryDPS;
    },
    getAliancaInfoConta(state) {
      return state.AliancaInfoConta;
    },
    getAliancaFormaPagamento(state) {
      return state.AliancaFormaPagamento;
    },
    getAliancaObjInfoPagamento(state) {
      return state.AliancaObjInfoPagamento;
    },
    getAliancaPropostaFinalizada(state) {
      return state.AliancaPropostaFinalizada;
    },
    getAliancaPlanosEntidadeorgaoInfo(state) {
      return state.AliancaPlanosEntidadeorgaoInfo;
    },
    getAliancaPlanosLista(state) {
      return state.AliancaPlanosLista;
    },
    getAliancaPlanosFiltrosAbrangencias(state) {
      let listaabrangencia = state.AliancaPlanosFiltrosAbrangencias;
      let abrangencialabels = [];

      for (let i = 0; i < listaabrangencia.length; i++) {
        abrangencialabels[
          parseInt(listaabrangencia[i].value.trim(), 10)
        ] = listaabrangencia[i].text.trim();
      }

      return abrangencialabels;
    },
    getAliancaPlanosFiltrosAcomodacoes(state) {
      let listaacomodacao = state.AliancaPlanosFiltrosAcomodacoes;
      let acomodacaolabels = [];

      for (const item of listaacomodacao) {
        acomodacaolabels[item.value.trim()] = item.descri
          .trim()
          .replace("PRODUTO ODONTOLOGICO", "CONS. ODONTO")
          .replace("PRODUTO OPCIONAL", "PROD. OPCIONAL");
      }

      return acomodacaolabels;
    },
    getAliancaPlanosOperadorasWordpress(state) {
      return state.AliancaPlanosOperadorasWordpress;
    },
    getAliancaFaixaRemuneracao(state) {
      return state.AliancaFaixaRemuneracao;
    },
    getAliancaListaFaixaRemuneracao(state) {
      return state.AliancaListaFaixaRemuneracao;
    },
    getAliancaCodAux(state) {
      return state.AliancaCodAux;
    },
    getAliancaMinimoPreco(state) {
      return state.AliancaMinimoPreco;
    },
    getAliancaMaximoPreco(state) {
      return state.AliancaMaximoPreco;
    },
    getAliancaCodEnd(state) {
      return state.AliancaCodEnd;
    },
    getAliancaEndNumero(state) {
      return state.AliancaEndNumero;
    },
    getAliancaEndComplento(state) {
      return state.AliancaEndComplento;
    },
    getAliancaPlanosListaFormatado(state) {
      return state.AliancaPlanosListaFormatado;
    },
    getAliancaIdade(state) {
      let datanasc = state.AliancaDataNasc;
      datanasc =
        datanasc.substr(6, 4) +
        "/" +
        datanasc.substr(3, 2) +
        "/" +
        datanasc.substr(0, 2);

      let dataatual = new Date();
      let nascimento = new Date(datanasc);
      let diferenca = dataatual - nascimento;
      let idade = Math.floor(diferenca / 31557600000);

      return idade;
    },
    getAliancaPlanosOperadoras(state) {
      return state.AliancaPlanosOperadoras;
    },
    getAliancaStatusAnalise(state) {
      return state.AliancaStatusAnalise;
    },
    getAliancaListaOrgaoPub(state) {
      let orgaos = state.AliancaListaOrgaoPub;
      let optionsorgaos = [];

      for (let i = 0; i < orgaos.length; i++) {
        optionsorgaos.push({
          id: i,
          name: orgaos[i].nomeentidade,
        });
      }

      return optionsorgaos;
    },
    getAliancaListaOrgaoPubBruta(state) {
      return state.AliancaListaOrgaoPub;
    },
    getAliancaListaEntidadeClasse(state) {
      let entidades = state.AliancaListaEntidadeClasse;
      let optionsentidades = [];

      for (let i = 0; i < entidades.length; i++) {
        optionsentidades.push({
          id: i,
          name: entidades[i].nomeentidade,
        });
      }

      return optionsentidades;
    },
    getAliancaListaEntidadeClasseBruta(state) {
      return state.AliancaListaEntidadeClasse;
    },
    getAliancaListaProfissao(state) {
      return state.AliancaListaProfissao;
    },
    getAliancaProposta(state) {
      return state.AliancaProposta;
    },
    getSimuleAquiCep(state) {
      return state.simuleAqui.cep;
    },
    getSimuleAquiNome(state) {
      return state.simuleAqui.nome;
    },
    getSimuleAquiDataNasc(state) {
      return state.simuleAqui.datanasc;
    },
    getSimuleAquiEmail(state) {
      return state.simuleAqui.email;
    },
    getSimuleAquiTelefone(state) {
      return state.simuleAqui.telefone;
    },
    getSimuleAquiEstadoApi(state) {
      return state.simuleAqui.estadoapi;
    },
    getSimuleAquiSelectedEntidade(state) {
      return state.simuleAqui.selected_entidade;
    },
    getSimuleAquiSelectedOrgao(state) {
      return state.simuleAqui.selected_orgao;
    },
    getSimuleAquiSelectedOrgaoCod(state) {
      return state.simuleAqui.selected_orgao_cod;
    },
    getSimuleAquiSelectedProfissao(state) {
      return state.simuleAqui.selected_profissao;
    },
    getSimuleAquiEntidades(state) {
      return state.simuleAqui.options_entidades;
    },
    getSimuleAquiOrgaos(state) {
      return state.simuleAqui.options_orgaos;
    },
    getSimuleAquiProfissoes(state) {
      return state.simuleAqui.options_profissoes;
    },
    getSimuleAquiLoader(state) {
      return state.simuleAqui.isLoading;
    },
    getSimuleAquiTipoOrgaoEntidade(state) {
      return state.simuleAqui.tipoorgaoentidade;
    },
    getSimuleAquiValidaCep(state) {
      return state.simuleAqui.validaCEP;
    },
    getSimuleAquiResetMode(state) {
      return state.simuleAqui.resetModeStep;
    },
    getSimuleAquiConsentimentoLgpd(state) {
      return state.simuleAqui.consentimentolgpd;
    },
    getSimuleAquiErrors(state) {
      return state.simuleAqui.errors;
    },
    getSimuleAquiIncluirDependente(state) {
      return state.simuleAqui.incluirDependente;
    },
    getSimuleAquiDependentes(state) {
      return state.simuleAqui.dependentes;
    },
    getSimuleAquiFinalizaProcesso(state) {
      return state.simuleAqui.finalizaprocesso;
    },
    getSimuleAquiExibeFinaliza(state) {
      return state.simuleAqui.exibefinaliza;
    },
    getSimuleAquiGrauParentesco(state) {
      return state.simuleAqui.options_grauparentesco;
    },
    getSimuleAquiSelectedFaixa(state) {
      return state.simuleAqui.selected_faixa;
    },
    getSimuleAquiFaixaRemuneracao(state) {
      return state.simuleAqui.options_faixaremuneracao;
    },
    getSimuleAquiPreenchidoProfissoes(state) {
      return state.simuleAqui.preenchidoprofissoes;
    },
    getSimuleAquiTraducaoDatePicker(state) {
      return state.simuleAqui.traducaodatepicker;
    },
    getLeadObj(state) {
      function getAge(date) {
        let birthDate = new Date(date);
        let todayDate = new Date();

        let age;

        if (
          todayDate.getMonth() > birthDate.getMonth() ||
          (todayDate.getMonth() === birthDate.getMonth() &&
            todayDate.getDate() >= birthDate.getDate())
        ) {
          age = todayDate.getFullYear() - birthDate.getFullYear();
        } else {
          age = todayDate.getFullYear() - birthDate.getFullYear() - 1;
        }

        return age;
      }

      const itemsDependentes = state.AliancaObjDependentes
        ? state.AliancaObjDependentes.map((el) => {
            return {
              tipoUsuario: "D",
              idadeInicial: getAge(el.DataNascDep),
            };
          })
        : [];

      const lead = {
        simulacao: {
          nome: state.AliancaNome,
          email: state.AliancaEmail,
          ddd: state.AliancaTelefone
            ? state.AliancaTelefone.split(" ")[0]
                .replace("(", "")
                .replace(")", "")
            : "",
          telefone: state.AliancaTelefone
            ? state.AliancaTelefone.split(" ")[1].replace("-", "")
            : "",
          uf: state.AliancaEndUF,
          cpf: state.AliancaUsrCPF ? state.AliancaUsrCPF : '00000000000',
          faixaRemuneracao: state.simuleAqui.selected_faixa,
          codigoSubFat: state.AliancaSubFatura,
          dataNascimento: state.AliancaDataNasc
            ? state.AliancaDataNasc.split("/")
                .reverse()
                .join("")
            : state.AliancaDataNasc,
          quantidadeDependentes: state.AliancaObjDependentes
            ? state.AliancaObjDependentes.length
            : 0,
          codigoMunicipio: state.AliancaEndCidade,
          cidadeMuninicipio: state.AliancaEndCidade,
          codigoConvenio: state.AliancaNumeroContrato,
          codigoMidia: "000014",
          tipoServico: "",
          canalVendas: "",
        },
        itemsSimulacao: [
          {
            tipoUsuario: "T",
            idadeInicial: getAge(
              state.AliancaDataNasc.split("/")
                .reverse()
                .join("")
            ),
          },
          ...itemsDependentes,
        ],
      };
      return lead;
    },
  },
  mutations: {
    mutAliancaFaixaRemuneracaoSelecionada(state, payload) {
      state.AliancaFaixaRemuneracaoSelecionada = payload;
    },
    mutResetState(state) {
      Object.assign(state, defaultState());
    },
    mutAliancaModalAbandonoAtivado(state, payload) {
      state.modalSair = payload;
    },
    mutAliancaModalAbandonocreateExitCache(state, payload) {
      state.modalSairAtivado = payload;
      this.setCache("modalSairAtivado", state.modalSairAtivado);
    },
    mutAliancaQLCEcommerce(state, value) {
      state.AliancaQLCEcommerce = value;
    },
    mutAliancaTermos(state, value) {
      state.AliancaTermos = value;
    },
    mutAliancaLogo(state, value) {
      state.AliancaLogo = value;
    },
    mutAliancaCEP(state, value) {
      state.AliancaCEP = value;
    },
    mutAliancaProxEtapa(state, value) {
      state.AliancaProxEtapa = value;
    },
    mutAliancaEstadoID(state, value) {
      state.AliancaEstadoID = value;
    },
    mutAliancaFuncPub(state, value) {
      state.AliancaFuncPub = value;
    },
    mutAliancaOrgaoPub(state, value) {
      state.AliancaOrgaoPub = value;
    },
    mutAliancaEntidadeClasse(state, value) {
      state.AliancaEntidadeClasse = value;
    },
    mutAliancaProfissao(state, value) {
      state.AliancaProfissao = value;
    },
    mutAliancaNome(state, value) {
      state.AliancaNome = value;
    },
    mutAliancaDataNasc(state, value) {
      state.AliancaDataNasc = value;
    },
    mutAliancaPossuiDep(state, value) {
      state.AliancaPossuiDep = value;
    },
    mutAliancaObjDependentes(state, value) {
      state.AliancaObjDependentes = value;
    },
    mutAliancaBreakPlanos(state, value) {
      state.AliancaBreakPlanos = value;
    },
    mutAliancaEmail(state, value) {
      state.AliancaEmail = value;
    },
    mutAliancaTelefone(state, value) {
      state.AliancaTelefone = value;
    },
    mutAliancaConsentimentoLGPD(state, value) {
      state.AliancaConsentimentoLGPD = value;
    },
    mutAliancaObjCadastro(state, value) {
      state.AliancaObjCadastro = value;
    },
    mutAliancaEndBairro(state, value) {
      state.AliancaEndBairro = value;
    },
    mutAliancaEndComp(state, value) {
      state.AliancaEndComp = value;
    },
    mutAliancaEndCidade(state, value) {
      state.AliancaEndCidade = value;
    },
    mutAliancaEndRua(state, value) {
      state.AliancaEndRua = value;
    },
    mutAliancaEndGia(state, value) {
      state.AliancaEndGia = value;
    },
    mutAliancaEndIbge(state, value) {
      state.AliancaEndIbge = value;
    },
    mutAliancaEndTipo(state, value) {
      state.AliancaEndTipo = value;
    },
    mutAliancaEndUF(state, value) {
      state.AliancaEndUF = value;
    },
    mutAliancaOrgEnt(state, value) {
      state.AliancaOrgEnt = value;
    },
    mutAliancaSelectedPlano(state, value) {
      state.AliancaSelectedPlano = value;
    },
    mutAliancaSelectedPlanoProtheus(state, value) {
      state.AliancaSelectedPlanoProtheus = value;
    },
    mutAliancaNumeroContrato(state, value) {
      state.AliancaNumeroContrato = value;
    },
    mutAliancaSubFatura(state, value) {
      state.AliancaSubFatura = value;
    },
    mutAliancaObjLogin(state, value) {
      state.AliancaObjLogin = value;
    },
    mutAliancaUsrCPF(state, value) {
      state.AliancaUsrCPF = value;
    },
    mutAliancaUsrSenha(state, value) {
      state.AliancaUsrSenha = value;
    },
    mutAliancaTipoEndereco(state, value) {
      state.AliancaTipoEndereco = value;
    },
    mutAliancaGeneroTitular(state, value) {
      state.AliancaGeneroTitular = value;
    },
    mutAliancaSexoTitular(state, value) {
      state.AliancaSexoTitular = value;
    },
    mutAliancaDocumentoTipo(state, value) {
      state.AliancaDocumentoTipo = value;
    },
    mutAliancaDocumentoNumero(state, value) {
      state.AliancaDocumentoNumero = value;
    },
    mutAliancaDocumentoOrgao(state, value) {
      state.AliancaDocumentoOrgao = value;
    },
    mutAliancaDocumentoUf(state, value) {
      state.AliancaDocumentoUf = value;
    },
    mutAliancaDocumentoDtExpedicao(state, value) {
      state.AliancaDocumentoDtExpedicao = value;
    },
    mutAliancaTitularNomeMae(state, value) {
      state.AliancaTitularNomeMae = value;
    },
    mutAliancaTitularEstadoCivil(state, value) {
      state.AliancaTitularEstadoCivil = value;
    },
    mutAliancaTitularDataAdmissaoOrgao(state, value) {
      state.AliancaTitularDataAdmissaoOrgao = value;
    },
    mutAliancaMatriculaRegOrgaoEntidade(state, value) {
      state.AliancaMatriculaRegOrgaoEntidade = value;
    },
    mutAliancaLotacaoOrgao(state, value) {
      state.AliancaLotacaoOrgao = value;
    },
    mutAliancaTitularCertidaoNascVivo(state, value) {
      state.AliancaTitularCertidaoNascVivo = value;
    },
    mutAliancaFlagPortabilidade(state, value) {
      state.AliancaFlagPortabilidade = value;
    },
    mutAliancaObjDPS(state, value) {
      state.AliancaObjDPS = value;
    },
    mutAliancaHistoryDPS(state, value) {
      state.AliancaHistoryDPS = value;
    },
    mutAliancaInfoConta(state, value) {
      state.AliancaInfoConta = value;
    },
    mutAliancaFormaPagamento(state, value) {
      state.AliancaFormaPagamento = value;
    },
    mutAliancaObjInfoPagamento(state, value) {
      state.AliancaObjInfoPagamento = value;
    },
    mutAliancaPropostaFinalizada(state, value) {
      state.AliancaPropostaFinalizada = value;
    },
    mutAliancaPlanosEntidadeorgaoInfo(state, value) {
      state.AliancaPlanosEntidadeorgaoInfo = value;
    },
    mutAliancaPlanosLista(state, value) {
      state.AliancaPlanosLista = value;
    },
    mutAliancaPlanosListaFormatadoDireto(state, value) {
      state.AliancaPlanosListaFormatado = value;
    },
    mutAliancaResetPlanosListaFormatado(state) {
      state.AliancaPlanosListaFormatado = [];
    },
    mutAliancaPlanosListaFormatado(state, value) {
      let arr = state.AliancaPlanosListaFormatado;
      const { 
        bi3_codint,
        bi3_versao,
        bqc_numcon,
        bqc_subcon,
        bqc_vercon,
        bqc_versub,
        calculostatus,
        codOperadora,
        codPlano,
        codRegraAuxilio,
        convenio,
        dataLimiteVenda,
        descricaoTipo,
        exibirplano,
        operadora,
        plano,
        subfatura,
        tipoPlano
      } = value.plano;
      let novoplano = {
        planoid: value.plano.codPlano,
        operadoraid: value.plano.operadora,
        descplano: value.plano.plano,
        cobertura: value.plano.cobertura,
        tipo: value.plano.descricaoTipo,
        acomodacao: value.plano.acomodacao,
        coparticipacao: value.plano.coparticipacao,
        valor: value.plano.valor,
        valor_aux: value.plano.valor_aux,
        codoperadora: value.plano.codOperadora,
        bi3_codint,
        bi3_versao,
        bqc_numcon,
        bqc_subcon,
        bqc_vercon,
        bqc_versub,
        calculostatus,
        codOperadora,
        codPlano,
        codRegraAuxilio,
        convenio,
        dataLimiteVenda,
        descricaoTipo,
        exibirplano,
        operadora,
        plano,
        subfatura,
        tipoPlano
      };
      arr.push(novoplano);
      state.AliancaPlanosListaFormatado = arr;
    },
    mutAliancaPlanosFiltrosAbrangencias(state, value) {
      state.AliancaPlanosFiltrosAbrangencias = value;
    },
    mutAliancaPlanosFiltrosAcomodacoes(state, value) {
      state.AliancaPlanosFiltrosAcomodacoes = value;
    },
    mutAliancaPlanosOperadorasWordpress(state, value) {
      state.AliancaPlanosOperadorasWordpress = value;
    },
    mutAliancaSinglePlano(state, value) {
      state.AliancaPlanosLista[value.indiceid] = value.plano;
    },
    mutAliancaFaixaRemuneracao(state, value) {
      state.AliancaFaixaRemuneracao = value;
    },
    mutAliancaListaFaixaRemuneracao(state, value) {
      state.AliancaListaFaixaRemuneracao = value;
    },
    mutAliancaCodAux(state, value) {
      state.AliancaCodAux = value;
    },
    mutAliancaMinimoPreco(state, value) {
      state.AliancaMinimoPreco = value;
    },
    mutAliancaMaximoPreco(state, value) {
      state.AliancaMaximoPreco = value;
    },
    mutAliancaCodEnd(state, value) {
      state.AliancaCodEnd = value;
    },
    mutAliancaEndNumero(state, value) {
      state.AliancaEndNumero = value;
    },
    mutAliancaEndComplento(state, value) {
      state.AliancaEndComplento = value;
    },
    mutAliancaPlanosOperadoras(state, value) {
      state.AliancaPlanosOperadoras = value;
    },
    mutAliancaStatusAnalise(state, value) {
      state.AliancaStatusAnalise = value;
    },
    mutAliancaListaOrgaoPub(state, value) {
      state.AliancaListaOrgaoPub = value;
    },
    mutAliancaListaEntidadeClasse(state, value) {
      state.AliancaListaEntidadeClasse = value;
    },
    mutAliancaListaProfissao(state, value) {
      state.AliancaListaProfissao = value;
    },
    mutAliancaProposta(state, value) {
      state.AliancaProposta = value;
    },
    mutSimuleAquiCep(state, value) {
      state.simuleAqui.cep = value;
    },
    mutSimuleAquiNome(state, value) {
      state.simuleAqui.nome = value;
    },
    mutSimuleAquiDataNasc(state, value) {
      state.simuleAqui.datanasc = value;
    },
    mutSimuleAquiEmail(state, value) {
      state.simuleAqui.email = value;
    },
    mutSimuleAquiTelefone(state, value) {
      state.simuleAqui.telefone = value;
    },
    mutSimuleAquiEstadoApi(state, value) {
      state.simuleAqui.estadoapi = value;
    },
    mutSimuleAquiSelectedEntidade(state, value) {
      state.simuleAqui.selected_entidade = value;
    },
    mutSimuleAquiSelectedOrgao(state, value) {
      state.simuleAqui.selected_orgao = value;
    },
    mutSimuleAquiSelectedOrgaoCod(state, value) {
      state.simuleAqui.selected_orgao_cod = value;
    },
    mutSimuleAquiSelectedProfissao(state, value) {
      state.simuleAqui.selected_profissao = value;
    },
    mutSimuleAquiEntidades(state, value) {
      state.simuleAqui.options_entidades = value;
    },
    mutSimuleAquiOrgaos(state, value) {
      state.simuleAqui.options_orgaos = value;
    },
    mutSimuleAquiProfissoes(state, value) {
      state.simuleAqui.options_profissoes = value;
    },
    mutSimuleAquiLoader(state, value) {
      state.simuleAqui.isLoading = value;
    },
    mutSimuleAquiTipoOrgaoEntidade(state, value) {
      state.simuleAqui.tipoorgaoentidade = value;
    },
    mutSimuleAquiValidaCep(state, value) {
      state.simuleAqui.validaCEP = value;
    },
    mutSimuleAquiResetMode(state, value) {
      state.simuleAqui.resetModeStep = value;
    },
    mutSimuleAquiConsentimentoLgpd(state, value) {
      state.simuleAqui.consentimentolgpd = value;
    },
    mutSimuleAquiErrors(state, value) {
      state.simuleAqui.errors = value;
    },
    mutSimuleAquiIncluirDependente(state, value) {
      state.simuleAqui.incluirDependente = value;
    },
    mutSimuleAquiDependentes(state, value) {
      state.simuleAqui.dependentes = value;
    },
    mutSimuleAquiFinalizaProcesso(state, value) {
      state.simuleAqui.finalizaprocesso = value;
    },
    mutSimuleAquiExibeFinaliza(state, value) {
      state.simuleAqui.exibefinaliza = value;
    },
    mutSimuleAquiGrauParentesco(state, value) {
      state.simuleAqui.options_grauparentesco = value;
    },
    mutSimuleAquiSelectedFaixa(state, value) {
      state.simuleAqui.selected_faixa = value;
    },
    mutSimuleAquiFaixaRemuneracao(state, value) {
      state.simuleAqui.options_faixaremuneracao = value;
    },
    mutSimuleAquiPreenchidoProfissoes(state, value) {
      state.simuleAqui.preenchidoprofissoes = value;
    },
    mutSimuleAquiTraducaoDatePicker(state, value) {
      state.simuleAqui.traducaodatepicker = value;
    },
  },
  actions: {
    setCache(section, data) {
      if (sessionStorage) {
        sessionStorage.setItem(section, JSON.stringify(data));
        return true;
      } else {
        return false;
      }
    },
    async disAliancaGetListaAuxilio(context) {
      let codRegraAux = await lerAuxilioSaude({
        codConvenio: context.getters.getAliancaNumeroContrato,
        codSubFat: context.getters.getAliancaSubFatura,
        tipoAcesso: "3",
      });

      if (codRegraAux.length > 0) {
        context.commit("mutAliancaCodAux", codRegraAux[0].codAux);

        const AuxList = [];
        const listaAuxilio = await lerAuxilio({
          idade: 0,
          codAuxilio: codRegraAux[0].codAux,
        });

        for (const item of listaAuxilio) {
          const { zzp_codrem, zzp_tpserv, zzp_confain } = item;
          const Valor = {
            minimo: item.zzp_valini,
            maximo: item.zzp_valfini,
            value: `${item.zzp_valini}-${item.zzp_valfini}`,
            text: `${item.zzp_valini} - ${item.zzp_valfini}`,
            zzp_codrem,
            zzp_tpserv,
            zzp_confain
          };
          if (
            !AuxList.find(
              (auxItem) => JSON.stringify(auxItem) === JSON.stringify(Valor)
            )
          ) {
            AuxList.push(Valor);
          }
        }

        context.commit("mutAliancaListaFaixaRemuneracao", AuxList);
      }
    },
    async disAliancaOperadorasConvenio(context) {
      let operadoras = await lerOperadoras({
        codigoConvenio: context.getters.getAliancaNumeroContrato,
        codigoCliente: "",
        codigoSubFat: context.getters.getAliancaSubFatura,
        migracao: "",
        data: "",
      });

      if (operadoras.length > 0) {
        let operadorasObj = {};

        operadoras.forEach((el) => {
          operadorasObj[el.CODIGO_OPERADORA] = el;
        });

        context.commit("mutAliancaPlanosOperadoras", operadorasObj);
      }
    },
    async disAliancaEntidadeInfo(context) {
      /* let resFuncPub = context.getters.getAliancaFuncPub
            let selected_entidadeorgao = ''
    
            if (resFuncPub != null){
              if (resFuncPub == 'Sim'){
                selected_entidadeorgao = context.getters.getAliancaOrgaoPub
              } else {
                selected_entidadeorgao = context.getters.getAliancaEntidadeClasse
              }
            } else {
                return false
              } */

      let contrato =
        context.getters.getAliancaNumeroContrato +
        "-" +
        context.getters.getAliancaSubFatura;
      /* let entidadeorgaoinfo = await buscarEntidadeOrgaoAPI(selected_entidadeorgao) */
      let entidadeorgaoinfo = await buscarEntidadeOrgaoContrato(contrato);

      if (entidadeorgaoinfo) {
        context.commit("mutAliancaPlanosEntidadeorgaoInfo", [
          {
            id: entidadeorgaoinfo.id,
            slug: entidadeorgaoinfo.slug,
            titulo: entidadeorgaoinfo.titulo.replace("\u00e7\u00e3", "çã"),
            logo: entidadeorgaoinfo.custom_fields.logo,
            convenio: entidadeorgaoinfo.custom_fields.convenio,
            // profissoes_id: entidadeorgaoinfo.custom_fields.profissoes_id,
            // profissoes_slug: entidadeorgaoinfo.custom_fields.profissoes_slug,
            zap: entidadeorgaoinfo.custom_fields.zap,
            simulacao: entidadeorgaoinfo.custom_fields.simulacao,
            subfatura: entidadeorgaoinfo.custom_fields.subfatura,
            numerocontrato: entidadeorgaoinfo.custom_fields.numerocontrato,
            planos: entidadeorgaoinfo.custom_fields.planos,
            quempodeaderir: entidadeorgaoinfo.custom_fields.quempodeaderir,
            carencia: entidadeorgaoinfo.custom_fields.carencia,
            auxilio: entidadeorgaoinfo.custom_fields.auxilio,
            // operadoras: entidadeorgaoinfo.custom_fields.operadoras,
            comoaderir: entidadeorgaoinfo.custom_fields.comoaderir,
            duvidas: entidadeorgaoinfo.custom_fields.duvidas,
          },
        ]);

        // let numerocontrato = entidadeorgaoinfo.custom_fields.numerocontrato
        // let subfatura = entidadeorgaoinfo.custom_fields.subfatura
        // let operadoras = entidadeorgaoinfo.custom_fields.operadoras
        // context.commit('mutAliancaNumeroContrato', numerocontrato)
        // context.commit('mutAliancaSubFatura', subfatura)
        // context.commit('mutAliancaPlanosOperadorasWordpress', operadoras)

        // console.log('Contrato e subfatura Wordpress: ', numerocontrato, subfatura)
        console.log(
          'Foi obtido entidade "' +
            entidadeorgaoinfo.titulo.replace("\u00e7\u00e3", "çã") +
            '" no Wordpress'
        );
        return true;
      } else {
        console.log("Não foi encontrado a entidade no Wordpress");
        context.commit("mutAliancaPlanosEntidadeorgaoInfo", []);
        return false;
      }
    },
    async disAliancaPlanosLista(context) {
      const planos = await buscarPlanosAPI({
        codConvenio: context.getters.getAliancaNumeroContrato,
        codSubFat: context.getters.getAliancaSubFatura,
        codCliente: "",
        tipoAcesso: "2",
        tipoUsuario: "T",
        idParentesco: "",
        idade: context.getters.getAliancaIdade,
        idEstadoCivil: "S",
        uf: context.getters.getAliancaEndUF,
      });

      const listaplanos = planos.map((el) => {
        return {
          codOperadora: el.codOperadora,
          operadora: el.operadora,
          codPlano: el.codPlano,
          plano: el.plano,
          acomodacao: el.acomodacao,
          cobertura: el.cobertura,
          coparticipacao: el.coparticipacao,
          bqc_numcon: el.bqc_numcon,
          bqc_vercon: el.bqc_vercon,
          bqc_subcon: el.bqc_subcon,
          bqc_versub: el.bqc_versub,
          bi3_codint: el.bi3_codint,
          bi3_versao: el.bi3_versao,
          dataLimiteVenda: el.dataLimiteVenda,
          convenio: el.convenio,
          tipoPlano: el.tipoPlano,
          descricaoTipo: el.descricaoTipo,
          codRegraAuxilio: el.codRegraAuxilio,
          subfatura: el.subfatura,
          valor: 0,
          valor_aux: 0,
          calculostatus: false,
          exibirplano: false,
        };
      });

      context.commit("mutAliancaPlanosLista", listaplanos);

      const socket = io(process.env.VUE_APP_BUSCAR_PLANOS_WEBSOCKET, {
        transports: ["websocket"],
      });

      let deplista = context.getters.getAliancaObjDependentes || [];

      socket.emit("chama:ler:planos", {
        idade: context.getters.getAliancaIdade,
        idEstadoCivil: "S",
        uf: context.getters.getAliancaEndUF,
        codConvenio: context.getters.getAliancaNumeroContrato,
        codSubFat: context.getters.getAliancaSubFatura,
        codCliente: "",
        codRem:
          context.state.AliancaFaixaRemuneracaoSelecionada ?
          context.state.AliancaFaixaRemuneracaoSelecionada.zzp_codrem : '',
        tipoAcesso: "2",
        tpServ:
          context.state.AliancaFaixaRemuneracaoSelecionada ?
          context.state.AliancaFaixaRemuneracaoSelecionada.zzp_tpserv : '',
        tipoentidadeorgao: context.getters.getAliancaFuncPub,
        codRegramento: context.getters.getAliancaCodAux,
        faixaRemuneracaoInicial:
          context.getters.getAliancaFaixaRemuneracao ?
          context.getters.getAliancaFaixaRemuneracao.minimo : '',
        faixaRemuneracaoFinal:
          context.getters.getAliancaFaixaRemuneracao ?
          context.getters.getAliancaFaixaRemuneracao.maximo : '',
        dependentes: deplista.map((dependente) => {
          let datanasc = dependente.DataNascDep;
          datanasc =
            datanasc.substr(6, 4) +
            "/" +
            datanasc.substr(3, 2) +
            "/" +
            datanasc.substr(0, 2);

          let dataatual = new Date();
          let nascimento = new Date(datanasc);
          let diferenca = dataatual - nascimento;
          let idade = Math.floor(diferenca / 31557600000);

          return {
            idade,
            idParentesco: dependente.GrauParentescoDep,
            idEstadoCivil: dependente.EstadoCivilDep,
          };
        }),
      });

      let indiceid = 0;

      socket.on("ler:planos", (plano) => {
        
        const valorfinal = plano.valor - plano.valor_aux;

        if (
          valorfinal < context.getters.getAliancaMinimoPreco &&
          valorfinal > 0
        ) {
          context.commit("mutAliancaMinimoPreco", valorfinal);
        }

        if (
          valorfinal > context.getters.getAliancaMaximoPreco &&
          valorfinal > 0
        ) {
          context.commit("mutAliancaMaximoPreco", valorfinal);
        }

        const planoFormatado = {
          plano,
          indiceid,
        };

        indiceid += 1;

        // ja pode entrar na lista formatada
        context.commit("mutAliancaPlanosListaFormatado", planoFormatado);
      });

      // context.dispatch('disValidaPlanoExibicao')

      context.dispatch("disAliancaOperadorasConvenio");
    },
    async disAliancaPlanosFiltros(context) {
      let listaabrangencia = await lerAbrangencia();
      let listaacomodacao = await lerAcomodacao();

      context.commit("mutAliancaPlanosFiltrosAbrangencias", listaabrangencia);
      context.commit("mutAliancaPlanosFiltrosAcomodacoes", listaacomodacao);
    },
    async disAliancaGetOrgaos(context) {
      let orgaos = [];
      let tipoorgao = [3, 4, 5, 1];

      for (const item of tipoorgao) {
        let resporgaos = await lerEntidadesOrgaosProtheus({
          nomeConvenio: "",
          nomeSubFat: "",
          codigoConvenio: "",
          codigoSubFat: "",
          tipoOrgao: item,
        });

        if (resporgaos.length > 0) {
          for (const orgao of resporgaos) {
            let nome = "";

            if (orgao.SUBFAT_DESCRICAO != "")
              nome = orgao.NOME_REDUZIDO + " - " + orgao.SUBFAT_DESCRICAO;
            else nome = orgao.NOME_REDUZIDO;

            if (orgao.TIPO_ORGAO == "3")
              orgaos.push({
                nomeentidade: nome + " - Orgão Federal",
                codcontrato: orgao.CODIGO_CONVENIO,
                codsubfatura: orgao.SUBFATURA,
              });
            else if (orgao.TIPO_ORGAO == "4")
              orgaos.push({
                nomeentidade: nome + " - Orgão Estadual",
                codcontrato: orgao.CODIGO_CONVENIO,
                codsubfatura: orgao.SUBFATURA,
              });
            else if (orgao.TIPO_ORGAO == "5")
              orgaos.push({
                nomeentidade: nome + " - Orgão Municipal",
                codcontrato: orgao.CODIGO_CONVENIO,
                codsubfatura: orgao.SUBFATURA,
              });
            else
              orgaos.push({
                nomeentidade: nome,
                codcontrato: orgao.CODIGO_CONVENIO,
                codsubfatura: orgao.SUBFATURA,
              });
          }
        }
      }
      context.commit("mutAliancaListaOrgaoPub", orgaos);
      return;
    },
    async disAliancaGetEntidades(context) {
      let entidades = [];
      let tipoorgao = [2]; // 1 possivelmente

      for (const item of tipoorgao) {
        let resporgaos = await lerEntidadesOrgaosProtheus({
          nomeConvenio: "",
          nomeSubFat: "",
          codigoConvenio: "",
          codigoSubFat: "",
          tipoOrgao: item,
        });

        if (resporgaos.length > 0) {
          for (const orgao of resporgaos) {
            let nome = "";

            if (orgao.SUBFAT_DESCRICAO != "")
              nome = orgao.NOME_REDUZIDO + " - " + orgao.SUBFAT_DESCRICAO;
            else nome = orgao.NOME_REDUZIDO;

            if (orgao.TIPO_ORGAO == "2")
              entidades.push({
                nomeentidade: nome + " - Entidade Privada",
                codcontrato: orgao.CODIGO_CONVENIO,
                codsubfatura: orgao.SUBFATURA,
              });
            else
              entidades.push({
                nomeentidade: nome,
                codcontrato: orgao.CODIGO_CONVENIO,
                codsubfatura: orgao.SUBFATURA,
              });
          }
        }
      }
      context.commit("mutAliancaListaEntidadeClasse", entidades);
    },
    async disObterOcupacoes(context) {
      let listaocupacoes = await listarOcupacoes();

      context.commit("mutAliancaListaProfissao", listaocupacoes);

      return listaocupacoes;
    },
    // AQUI
    async disValidaPlanoExibicao(context) {
      let listaplanos = context.getters.getAliancaPlanosLista;
      let deplista = context.getters.getAliancaObjDependentes;

      for (let i = 0; i < listaplanos.length; i++) {
        if (context.getters.getAliancaBreakPlanos) {
          break;
        }

        let objplano = {
          indiceid: i,
          plano: {
            codOperadora: listaplanos[i].codOperadora,
            operadora: listaplanos[i].operadora,
            codPlano: listaplanos[i].codPlano,
            plano: listaplanos[i].plano,
            acomodacao: listaplanos[i].acomodacao,
            cobertura: listaplanos[i].cobertura,
            coparticipacao: listaplanos[i].coparticipacao,
            bqc_numcon: listaplanos[i].bqc_numcon,
            bqc_vercon: listaplanos[i].bqc_vercon,
            bqc_subcon: listaplanos[i].bqc_subcon,
            bqc_versub: listaplanos[i].bqc_versub,
            bi3_codint: listaplanos[i].bi3_codint,
            bi3_versao: listaplanos[i].bi3_versao,
            dataLimiteVenda: listaplanos[i].dataLimiteVenda,
            convenio: listaplanos[i].convenio,
            tipoPlano: listaplanos[i].tipoPlano,
            descricaoTipo: listaplanos[i].descricaoTipo,
            codRegraAuxilio: listaplanos[i].codRegraAuxilio,
            subfatura: listaplanos[i].subfatura,
            valor: listaplanos[i].valor,
            valor_aux: listaplanos[i].valor_aux,
            calculostatus: listaplanos[i].calculostatus,
            exibirplano: listaplanos[i].exibirplano,
          },
        };

        console.log("Analisando plano " + i);

        let verificaestado = await verificaEstado({
          uf: context.getters.getAliancaEndUF,
          idOperadora: listaplanos[i].codOperadora,
          numeroContrato: listaplanos[i].bqc_numcon,
          versaoContrato: listaplanos[i].bqc_vercon,
          numeroSubContrato: listaplanos[i].bqc_subcon,
          versaoSubContrato: listaplanos[i].bqc_versub,
          idPlano: listaplanos[i].codPlano,
          versaoPlano: listaplanos[i].bi3_versao,
        });

        if (verificaestado.flag) {
          let verificaelegibilidade = await verificaElegibilidade({
            codEmp: listaplanos[i].codOperadora,
            numeroContrato: listaplanos[i].bqc_numcon,
            versaoContrato: listaplanos[i].bqc_vercon,
            numeroSubContrato: listaplanos[i].bqc_subcon,
            versaoSubContrato: listaplanos[i].bqc_versub,
            idPlano: listaplanos[i].codPlano,
            versaoPlano: listaplanos[i].bi3_versao,
            tipoUsuario: "T",
            idParentesco: "",
            idade: context.getters.getAliancaIdade,
            idEstadoCivil: "S",
          });

          if (deplista != null) {
            for (let j = 0; j < deplista.length; j++) {
              let datanasc = deplista[j].DataNascDep;
              datanasc =
                datanasc.substr(6, 4) +
                "/" +
                datanasc.substr(3, 2) +
                "/" +
                datanasc.substr(0, 2);

              let dataatual = new Date();
              let nascimento = new Date(datanasc);
              let diferenca = dataatual - nascimento;
              let idade = Math.floor(diferenca / 31557600000);

              let verificaelegibilidadedep = await verificaElegibilidade({
                codEmp: listaplanos[i].codOperadora,
                numeroContrato: listaplanos[i].bqc_numcon,
                versaoContrato: listaplanos[i].bqc_vercon,
                numeroSubContrato: listaplanos[i].bqc_subcon,
                versaoSubContrato: listaplanos[i].bqc_versub,
                idPlano: listaplanos[i].codPlano,
                versaoPlano: listaplanos[i].bi3_versao,
                tipoUsuario: "D",
                idParentesco: deplista[j].GrauParentescoDep,
                idade: idade,
                idEstadoCivil: deplista[j].EstadoCivilDep,
              });

              verificaelegibilidade.flag =
                verificaelegibilidade.flag && verificaelegibilidadedep.flag;
            }
          }

          if (verificaelegibilidade.flag) {
            let somatoriavalor = await lerValorPlano({
              idOperadora: listaplanos[i].codOperadora,
              numeroContrato: listaplanos[i].bqc_numcon,
              versaoContrato: listaplanos[i].bqc_vercon,
              numeroSubContrato: listaplanos[i].bqc_subcon,
              versaoSubContrato: listaplanos[i].bqc_versub,
              idPlano: listaplanos[i].codPlano,
              versaoPlano: listaplanos[i].bi3_versao,
              datBas: "",
              idadeBeneficiario: context.getters.getAliancaIdade,
              tipoUsuario: "T",
              grauParentesco: "C",
              ufTitular: context.getters.getAliancaEndUF,
            });
            somatoriavalor = somatoriavalor.valor;

            if (deplista != null) {
              for (let k = 0; k < deplista.length; k++) {
                let datanasc = deplista[k].DataNascDep;
                datanasc =
                  datanasc.substr(6, 4) +
                  "/" +
                  datanasc.substr(3, 2) +
                  "/" +
                  datanasc.substr(0, 2);

                let dataatual = new Date();
                let nascimento = new Date(datanasc);
                let diferenca = dataatual - nascimento;
                let idade = Math.floor(diferenca / 31557600000);

                let valplano = await lerValorPlano({
                  idOperadora: listaplanos[i].codOperadora,
                  numeroContrato: listaplanos[i].bqc_numcon,
                  versaoContrato: listaplanos[i].bqc_vercon,
                  numeroSubContrato: listaplanos[i].bqc_subcon,
                  versaoSubContrato: listaplanos[i].bqc_versub,
                  idPlano: listaplanos[i].codPlano,
                  versaoPlano: listaplanos[i].bi3_versao,
                  datBas: "",
                  idadeBeneficiario: idade,
                  tipoUsuario: "D",
                  grauParentesco: deplista[k].GrauParentescoDep,
                  ufTitular: context.getters.getAliancaEndUF,
                });

                somatoriavalor += valplano.valor;
              }
            }

            let today = new Date();
            today =
              today.getFullYear() +
              "" +
              (today.getMonth() + 1) +
              "" +
              today.getDate();

            let tipoentidadeorgao = context.getters.getAliancaFuncPub;
            let somatoriaux = 0;

            if (tipoentidadeorgao == "Sim") {
              somatoriaux = await lerValorAuxilio({
                codRegra: context.getters.getAliancaCodAux,
                codPla: listaplanos[i].codPlano,
                tipUsu: "T",
                idade: context.getters.getAliancaIdade,
                vl_plano: "0.00",
                codRem: "",
                tpServ: "",
                valIni: context.getters.getAliancaFaixaRemuneracao.minimo,
                valFin: context.getters.getAliancaFaixaRemuneracao.maximo,
                dt_atual: today,
                vl_pl_base: "0.00",
              });
              somatoriaux = somatoriaux.valor;

              if (deplista != null) {
                for (let k = 0; k < deplista.length; k++) {
                  let datanasc = deplista[k].DataNascDep;
                  datanasc =
                    datanasc.substr(6, 4) +
                    "/" +
                    datanasc.substr(3, 2) +
                    "/" +
                    datanasc.substr(0, 2);

                  let dataatual = new Date();
                  let nascimento = new Date(datanasc);
                  let diferenca = dataatual - nascimento;
                  let idade = Math.floor(diferenca / 31557600000);

                  let valaux = await lerValorAuxilio({
                    codRegra: context.getters.getAliancaCodAux,
                    codPla: listaplanos[i].codPlano,
                    tipUsu: "D",
                    idade: idade,
                    vl_plano: "0.00",
                    codRem: "",
                    tpServ: "",
                    valIni: context.getters.getAliancaFaixaRemuneracao.minimo,
                    valFin: context.getters.getAliancaFaixaRemuneracao.maximo,
                    // valIni: deplista[k].FaixaRemuneracaoDep.split("-")[0],
                    // valFin: deplista[k].FaixaRemuneracaoDep.split('-')[1],
                    dt_atual: today,
                    vl_pl_base: "0.00",
                  });

                  somatoriaux += valaux.valor;
                }
              }
            }

            if (somatoriavalor > 0) {
              objplano.plano.valor = somatoriavalor;
              objplano.plano.valor_aux = somatoriaux;
              objplano.plano.calculostatus = true;
              objplano.plano.exibirplano = true;

              let valorfinal = somatoriavalor - somatoriaux;

              if (
                valorfinal < context.getters.getAliancaMinimoPreco &&
                valorfinal > 0
              ) {
                context.commit("mutAliancaMinimoPreco", valorfinal);
              }

              if (
                valorfinal > context.getters.getAliancaMaximoPreco &&
                valorfinal > 0
              ) {
                context.commit("mutAliancaMaximoPreco", valorfinal);
              }

              // ja pode entrar na lista formatada
              context.commit("mutAliancaPlanosListaFormatado", objplano);

              console.log("Plano " + i + " será exibido");
            } else {
              objplano.plano.calculostatus = true;
              objplano.plano.exibirplano = false;
              console.log("Plano " + i + " não passou no calculo do Preco");
            }
          } else {
            objplano.plano.exibirplano = false;
            console.log("Plano " + i + " não passou na verificaElegibilidade");
          }
        } else {
          objplano.plano.exibirplano = false;
          console.log("Plano " + i + " não passou na verificaEstado");
        }
        // context.commit('mutAliancaSinglePlano', objplano)
        console.log("Plano " + i + " analisado");
      }
      context.commit("mutAliancaStatusAnalise", true);
      console.log("Finalizou calculo dos planos");
    },
  },
});
